import { useCallback, useEffect, useRef } from 'react';
import { useAttendanceStore } from '@/store';

export function useAttendance(autoFetch = true) {
  const {
    todayAttendance,
    attendanceRecords,
    summary,
    paymentHistory,
    currentPayment,
    isLoading,
    error,
    fetchTodayAttendance,
    clockIn,
    clockOut,
    fetchMyAttendance,
    fetchMySummary,
    fetchPaymentRecord,
    clearError,
  } = useAttendanceStore();

  const hasFetched = useRef(false);

  const refresh = useCallback(async () => {
    const now = new Date();
    await Promise.all([
      fetchTodayAttendance(),
      fetchMySummary(now.getFullYear(), now.getMonth() + 1),
      fetchMyAttendance(),
    ]);
  }, [fetchTodayAttendance, fetchMySummary, fetchMyAttendance]);

  useEffect(() => {
    if (autoFetch && !hasFetched.current && !todayAttendance) {
      hasFetched.current = true;
      fetchTodayAttendance();
    }
  }, [autoFetch, fetchTodayAttendance, todayAttendance]);

  const canClockIn = todayAttendance?.canClockIn ?? true;
  const canClockOut = todayAttendance?.canClockOut ?? false;
  const isClockedIn = todayAttendance?.clockedIn ?? false;
  const isClockedOut = todayAttendance?.clockedOut ?? false;

  return {
    todayAttendance,
    attendanceRecords,
    summary,
    paymentHistory,
    currentPayment,
    isLoading,
    error,
    canClockIn,
    canClockOut,
    isClockedIn,
    isClockedOut,
    clockIn,
    clockOut,
    refresh,
    fetchTodayAttendance,
    fetchMyAttendance,
    fetchMySummary,
    fetchPaymentRecord,
    clearError,
  };
}

export default useAttendance;
